<template>
    <v-container fluid style="padding:0;">
        <v-layout column>
            <v-flex shrink>
                <h2>{{label}}</h2>
            </v-flex>
            <v-flex>
                <v-layout row>
                    <v-flex 
                        style="padding: 0 24px;"
                        :xs6="$vuetify.breakpoint.smAndUp"
                        :offset-xs6="$vuetify.breakpoint.smAndUp"
                        :xs12="$vuetify.breakpoint.xs"
                    >
                        <v-text-field
                            v-model="preparedSearch"
                            @change="$emit('change', $event)"
                            append-icon="search"
                            label="Suche"
                            single-line
                            hide-details
                        ></v-text-field>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex>
                <v-data-table
                    id="datatable-dsks"
                    class="mx-4"
                    :locale="'de-DE'"
                    :headers="headers"
                    :items="filteredItems"
                    :pagination.sync="preparedPagination"
                    :no-data-text="noDataTextComputed"
                    no-results-text="Keine Ergebnisse vorhanden"
                    :rows-per-page-items="[10,20,30]"
                    rows-per-page-text="Zeilen pro Seite"
                    
                >
                    <template v-slot:items="props">
                        <slot name="items" v-bind="props"></slot>
                    </template>
                    <template v-slot:pageText="props">
                        Zeile {{ props.pageStart ? props.pageStart : 0 }} - {{ props.pageStop ? props.pageStop : items.length }} von {{ props.itemsLength }}
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name: 'Datatable',

    props: {
        label: {
            type: String,
            default: ''
        },

        'no-data-text': {
            type: String,
            default: 'Keine Daten vorhanden'
        },

        items: {
            type: Array,
            default: () => []
        },

        headers: {
            type: Array,
            default: () => []
        },

        search: {
            type: String,
            default: undefined
        },

        pagination: {
            type: Object,
            default: () => undefined
        }
    },

    data: () => ({
        preparedPagination: undefined,

        preparedSearch: ''
    }),

    computed: {
        filteredItems() {
            if(!Array.isArray(this.items)) return [];
            
            return this.items.filter(item => {
                let preparedItem = {};

                for(let header of this.headers) {
                    preparedItem[header.value] = item[header.value]
                }

                return JSON.stringify(preparedItem).includes(this.preparedSearch)
            });
        },
        noDataTextComputed() {
            return this.noDataText
        }
    },

    watch: {
        search(search) {
            this.preparedSearch = search;
        },

        pagination(pagination) {
            this.preparedPagination = pagination;
        }
    }
}
</script>

<style>

</style>